import styles from './Universe26BannerVisual.module.css'
import universe26VisualMona from './assets/universe_26-visual-mona.webp'
import universe26VisualCurlyBrace from './assets/universe_26-visual-curlyBrace.webp'
import universe26VisualIcon1 from './assets/universe_26-visual-icon-1.svg'
import universe26VisualIcon2 from './assets/universe_26-visual-icon-2.svg'
import universe26VisualIcon3 from './assets/universe_26-visual-icon-3.svg'

type RectDefinition = {
  id: string
  icon: string | null
}

function createRects(length: number, iconsByIndex: Record<number, string>): RectDefinition[] {
  return Array.from({length}, (_, index) => ({
    id: `rect-${index + 1}`,
    icon: iconsByIndex[index] ?? null,
  }))
}

const desktopRects = createRects(7, {
  0: universe26VisualIcon1,
  3: universe26VisualIcon3,
  4: universe26VisualIcon2,
})

const mobileRects = createRects(19, {
  0: universe26VisualIcon1,
  4: universe26VisualIcon3,
  5: universe26VisualIcon2,
})

function renderRects(rects: RectDefinition[], delayDivider = 10) {
  return rects.map((rect, index) => (
    <div key={rect.id} className={styles.visualRect} style={{animationDelay: `${index / delayDivider}s`}}>
      {rect.icon ? <img src={rect.icon} alt="" /> : null}
    </div>
  ))
}

export function Universe26BannerVisual() {
  return (
    <>
      <div className={styles.visualDesktop}>
        <div className={styles.visualRectContainer}>{renderRects(desktopRects, 10)}</div>
        <div className={styles.visualBg}>
          <img src={universe26VisualCurlyBrace} className={styles.visualBgCurlyBrace} alt="" />
        </div>
        <img src={universe26VisualMona} className={styles.visualMona} alt="" />
      </div>
      <div className={styles.visualMobile}>
        <div className={styles.visualBg} />
        <div className={styles.visualRectContainer}>{renderRects(mobileRects, 15)}</div>
        <img src={universe26VisualMona} className={styles.visualMona} alt="" />
      </div>
    </>
  )
}
